// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"026c2e1e","194":"2b1fb796","593":"b52a192b","723":"be6581df","741":"01268927"}[chunkId] + ".chunk.css";
};